import React from 'react';
import PropTypes from 'prop-types';

import { Table as MUITable } from '@mui/material';

export const Table = props => <MUITable {...props} />;

Table.propTypes = {
  classes: PropTypes.object,
  component: PropTypes.elementType,
  padding: PropTypes.oneOf(['default', 'checkbox', 'none']),
  size: PropTypes.oneOf(['small', 'medium']),
  stickyHeader: PropTypes.bool
};

export default Table;
